import React, {useState} from "react";
import close from "../../images/Close.svg";
import http from "../../services/api/utilities/http";
const modal = {
    width:500,
    height:300,
    position:'absolute',
    zIndex:1000,
    background:'white',
    top:'50%',
    left:'50%',
    right:'50%',
    borderRadius:20,
    padding:40,
    transform: 'translate(-50%, -50%)',
    boxShadow:'rgba(0, 0, 0, 0.08)',
}
const closeStyle = {
    cursor:'pointer',
    position: 'absolute',
    right : 40
}
export default function SaveModal(props) {
    const [name , setName] = useState('')
    const [loading , setLoading] = useState(false)
    const save = e => {
        sendDataPreview()
    }
    const sendDataPreview = () => {
        setLoading(true)
        http.put('data_connector/data_pool_handler/'+props.uid+'/',
            {
                name:name,
                // data_source:props.uid,
                data_mapping:props.dataMapping,
                // table:props.tableDataPreview
            })
            .then(res => {
                console.log(res.data)
                // let data = res.data.data
                props.getData()
            })
            .catch(err=>{
                console.log(err.response)
                setLoading(false)
            })
    }
return(
           <>
               <div className="modal-back"></div>
               <div style={modal} className="-modal">
                   <img  onClick={() => props.selfClose()} style={closeStyle} src={close} alt="close"/>
                   <p className="f16 dark-gary fw700">Do You Want to Save This Process? </p>
                   <p className="mt-3 f14 fw300">You can save this process and come back when ever you want. </p>
                   <p className="f14 fw600 dark-gary mt-24 mb-3">Name</p>
                   <input onChange={e => setName(e.target.value)} placeholder="Enter a name for this process" type="text"/>
                   <div className="d-flex mt-24">
                       <div style={{width:197}} onClick={save} className={`btn ${name && 'btn-active'} ${loading && 'btn-loading-small'} btn btn-by-loading mr-24`}>
                           <p>save</p>
                           <p>saving</p>
                       </div>
                       <div style={{width:197,padding:'10px 0 0'}} className="btn btn-outline" onClick={() => props.close()}>don't save and close</div>
                   </div>
               </div>
           </>
)
}
